import i18n from '@/i18n'

export const defaultGroups = [
  {
    label: i18n.t('FILTER_CENTERS'),
    value: 'shops',
    filters: ['shop_id', 'terr_unit']
  },
  {
    label: i18n.t('FILTER_ADVERTS'),
    value: 'adverts',
    filters: ['advert_id', 'advert_exclusivist', 'advert_is_active', 'advert_has_incidences', 'advert_type']
  },
  {
    label: i18n.t('FILTER_CAMPAIGNS'),
    value: 'campaigns',
    filters: ['direction', 'product_id', 'campaign_scope', 'campaign_status', 'campaign_channel']
  },
  {
    label: i18n.t('FILTER_CAMPAIGNS'),
    value: 'dashboard_summary',
    filters: ['campaign_scope', 'campaign_channel']
  },
  {
    label: i18n.t('FILTER_CAMPAIGNS'),
    value: 'dashboard',
    filters: ['direction', 'campaign_id', 'campaign_scope', 'campaign_channel']
  },
  {
    label: i18n.t('FILTER_CAMPAIGNS'),
    value: 'dashboard_extended',
    filters: ['direction', 'campaign_id', 'campaign_scope', 'campaign_status_results']
  },
  {
    label: i18n.t('FILTER_USERS'),
    value: 'users',
    filters: ['user_role']
  }
]
